import React from 'react';
import IconButton from '@mui/material/IconButton';
import { ArrowBack as ArrowBackIcon } from '../icons';
import { useNavigate } from 'react-router-dom';

const BackButton = ({ color }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navigate back
  };

  return (
    <IconButton onClick={handleGoBack} color={color || "inherit"}>
      <ArrowBackIcon />
    </IconButton>
  );
};

export default BackButton;